import {
    Pipe, PipeTransform
} from "@angular/core";
import {
    ArrayUtil, Enum, EnumUtil, EnumValue, IEnumOption
} from "@shopliftr/common-js/data";

/**
 * Pipe to convert an enum to an array of IEnumOption objects for use in template @for loops
 */
@Pipe({
    name: "mgdEnumOptions"
})
export class EnumOptionsPipe implements PipeTransform {

    /**
     * Transforms an enum into an array of IEnumOption objects
     *
     * @param targetEnum The enum to convert
     * @param exclude Optional array of enum values to exclude from the results
     * @returns Array of IEnumOption objects with key, value, and display properties
     */
    transform(targetEnum: Enum, exclude?: Array<EnumValue>): Array<IEnumOption> {

        if (!targetEnum) {
            return [];
        }

        const options = EnumUtil.getEnumOptions(targetEnum);

        if (ArrayUtil.isEmpty(exclude)) {
            return options;
        }

        return options.filter((option) => !exclude.includes(option.value));
    }
}
